import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash-es';
import FilterSelect from './FilterSelect';
import SaveFilterSetting from './SaveFilterSetting';

import '@/pages/dashboard/assets/scss/components/filterSelect.scss';

interface FilterSaveProps {
  addFilterSchemeList: Function; // 添加方案方法
  editFilterSchemeList: Function; // 编辑方案方法
  deleteFilterSchemeList: Function; // 删除方案方法
  selectorSchemeList: Array<any>; // 筛选器方法list
  formValue: Object; // 筛选器值
  inputList: Array<Object>; // 页面渲染筛选器list
  filterSchemeChange: Function; // 方案更改方法
  filterSaveOnChange: Function; // 方案更改方法
  selectedValue: any; // 选择方案值
  setSelectedValue: any;
  filterModalInfo: { // 编辑弹窗
    filterModalType: string | 'edit' | 'add';
    filterModalVisible: boolean;
  };
  setFilterModalInfo: any;
}

const FilterSave = (props: FilterSaveProps) => {
  const {
    selectorSchemeList,
    formValue,
    inputList,
    filterSchemeChange,
    addFilterSchemeList,
    editFilterSchemeList,
    deleteFilterSchemeList,
    selectedValue,
    setSelectedValue,
    filterModalInfo,
    setFilterModalInfo,
  } = props;
  const [editFilter, setEditFilter] = useState({});
  const { filterModalType: type, filterModalVisible: visible } = filterModalInfo || {};

  useEffect(() => {
    // 用于编辑后能实时更新选中方案的内容
    const selectedVal = selectorSchemeList?.filter((item: any) => item?.filter_name === selectedValue?.filter_name)?.[0] || {};
    // 兜底没选中方案值
    if (!selectedVal?.filter_name) return setSelectedValue({});
    setSelectedValue(selectedVal);
    !isEmpty(selectedValue) && filterSchemeChange(selectedVal);
  }, [selectorSchemeList]);

  return (
    <>
      <FilterSelect
        selectedValue={selectedValue}
        selectorSchemeList={selectorSchemeList}
        setFilterModalInfo={setFilterModalInfo}
        setEditFilter={setEditFilter}
        setSelectedValue={setSelectedValue}
        filterSchemeChange={filterSchemeChange}
        deleteFilterSchemeList={deleteFilterSchemeList}
      />
      {
        visible && <SaveFilterSetting
          type={type}
          editFilter={editFilter}
          visible={visible}
          inputList={inputList}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          selectorSchemeList={selectorSchemeList}
          addFilterSchemeList={addFilterSchemeList}
          editFilterSchemeList={editFilterSchemeList}
          close={() => {
            setFilterModalInfo({
              filterModalType: '',
              filterModalVisible: false,
            });
            setEditFilter({});
          }}
          formValue={formValue}
        />
      }
    </>
  );
};

export default FilterSave;

